import React from 'react';
export type SyncState = 'connecting' | 'ok' | 'err';
interface SyncBadgeProps {
  state: SyncState;
  text: string;
}
export function SyncBadge({
  state,
  text
}: SyncBadgeProps) {
  const ballColor = state === 'ok' ? 'bg-green' : state === 'err' ? 'bg-red' : 'bg-amber';
  return <span className="text-[11px] font-bold text-[#8a8175] flex items-center gap-[5px]" data-id="element-194">
      <span className={`w-2 h-2 rounded-full ${ballColor}`} data-id="element-195"></span>
      <span data-id="element-196">{text}</span>
    </span>;
}